import { SessionEventBuffer } from "./sessionEventBuffer";
import { sessionUploader } from "./sessionUploaderInstance";

// events.jsonl の in-session 耐久性ハードニングを production で有効化する
// (foreground snapshot + beacon re-arm、既定 false を singleton だけ opt-in)。
// spec: docs/superpowers/specs/2026-07-25-events-in-session-durability-design.md §7 / X5。
export const sessionEventBuffer = new SessionEventBuffer(sessionUploader, undefined, {
  enableSnapshots: true,
});
